import React,{useState,useEffect} from 'react'
import {Box,Button,DataTable} from 'grommet'
import {withRouter} from 'react-router-dom'
import { Add } from 'grommet-icons';
import {TableLoadLayer, NavigationSnackBar } from '../../../components/utils/shared/shared';
import { APIRequest } from '../../../components/utils/shared/requests';
import {ShipmentSuccessNotification} from '../../../components/utils/shared/shipmentViewFunctions'

function OrgList (props) {
const [orgs, setOrgs] = useState([]);
const [load, setLoad] = useState(true)
const [organisationSucc, setOrganisationSucc] = useState(props.location.organisationSucc)
    useEffect(() => { 
      APIRequest('/organisations').then(result => {setOrgs(result); console.log(result); setLoad(false)})
      setTimeout(() => {
        setOrganisationSucc(undefined);
      }, 5000)
     },[]);
  return (
   <Box wrap flex="grow">
      <NavigationSnackBar title={'Organisations'} user={props.user} pages={[{name: 'Dashboard', link: '/dashboard'}]}  />
      {organisationSucc && (<ShipmentSuccessNotification label={"Organisation"} edit={props.location.edit} />)}
      <Box direction='row' justify='end'>
          <Button label="Create Organisation" margin='small' icon={<Add color='brand'/>} hoverIndicator onClick={() => props.history.push('/admin/organisations/new')}/>
        </Box>
        <Box elevation='medium' pad='small' margin='small' round >
          <DataTable paginate step={10} margin='small' background={{ header: { color: '#18445C'}, footer: { color: 'dark-3', opacity: 'strong' }, }}columns={[ {header:"ID",property:"id",primary:true,sortable:true,search:false}, {header:"Name",property:"name", search:true},{header:"Markup (%)",property:"markup"} ]} data={orgs}  onClickRow={({datum}) => {props.history.push({pathname:`/admin/organisations/edit/${datum.id}`})}} />
          {load && (<TableLoadLayer load={load} label={"Loading Organisations..."} />)}
        </Box>
   </Box>
  )
}

export default withRouter(OrgList)